import api from "../api";

export const newSubscription = async (params: any) => {
	let formData = new FormData();
	formData.append("start", params.start);
	formData.append("end", params.end);
	formData.append("value", params.value);
	formData.append("subscribe", params.subscribe);
	formData.append("plan", params.plan);
	formData.append("auto_renew", params.auto_renew ?? true);

	params.files.forEach((file: any) => {
		formData.append("files", file);
	});

	const { data } = await api.post("signature/signature/", formData);
	return data;
};

export const cancelSubscription = async (id: any) => {
	const { data } = await api.delete(`/signature/signature/${id}`);
	return data;
};

export const inactivateSubscription = async (id: any) => {
	const { data } = await api.patch(`/signature/signature/${id}`, {
		status: 2,
	});

	return data;
};

export const reactivateSubscription = async (id: any) => {
	const { data } = await api.patch(`/signature/signature/${id}`, {
		status: 1,
	});

	return data;
};

export const getSubscriptions = async (query?: string) => {
	if (query) {
		const { data } = await api.get(`/signature/profile?${query}`);
		return data;
	} else {
		const { data } = await api.get("/signature/profile/");
		return data;
	}
};

export const getSubscriptionHistory = async (id: any) => {
	const { data } = await api.get(`/manager/profile/${id}/signature`);

	return data;
};

export const getPlans = async (query?: string) => {
	if (query) {
		const { data } = await api.get(`signature/plan?${query}`);
		return data;
	} else {
		const { data } = await api.get("signature/plan/");
		return data;
	}
};

export const newPlan = async (params: any) => {
	const { data } = await api.post(`/signature/plan/`, params);
	return data;
};

export const getPlanDetails = async (planId: number) => {
	const { data } = await api.get(`/signature/plan/${planId}`);
	return data;
};

export const updatePlan = async (planId: number, params: any) => {
	const { data } = await api.patch(`/signature/plan/${planId}`, params);
	return data;
};

export const removePlan = async (planId: number) => {
	const { data } = await api.delete(`/signature/plan/${planId}`);
	return data;
};
